"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M7.2688 5.1541C5.9814 5.3797 4.753 6.1738 3.832 7.5554L2.168 6.446c1.187-1.7805 2.8662-2.9308 4.7556-3.2618 1.892-.3316 3.8902.1768 5.6764 1.5165 1.3987 1.049 2.8466 1.3716 4.1313 1.1464 1.2874-.2255 2.5157-1.0196 3.4367-2.4012l1.6641 1.1094c-1.187 1.7805-2.8663 2.9308-4.7556 3.2618-1.8921.3316-3.8902-.1768-5.6765-1.5164-1.3986-1.049-2.8466-1.3717-4.1312-1.1466zm0 6.0001c-1.2874.2255-2.5157 1.0196-3.4367 2.4012L2.168 12.446c1.187-1.7805 2.8662-2.9308 4.7556-3.2618 1.892-.3316 3.8902.1768 5.6764 1.5165 1.3987 1.0489 2.8466 1.3716 4.1313 1.1465 1.2874-.2256 2.5157-1.0197 3.4367-2.4013l1.6641 1.1095c-1.187 1.7804-2.8663 2.9307-4.7556 3.2617-1.8921.3316-3.8902-.1768-5.6765-1.5164-1.3986-1.049-2.8466-1.3717-4.1312-1.1465zM3.832 19.5554c.921-1.3816 2.1494-2.1757 3.4368-2.4012 1.2847-.2252 2.7326.0975 4.1312 1.1465 1.7863 1.3396 3.7844 1.848 5.6765 1.5164 1.8893-.331 3.5686-1.4813 4.7556-3.2617L20.168 15.446c-.921 1.3815-2.1493 2.1756-3.4367 2.4012-1.2847.2251-2.7326-.0976-4.1313-1.1465-1.7862-1.3397-3.7843-1.8481-5.6764-1.5165-1.8894.331-3.5687 1.4813-4.7556 3.2618l1.664 1.1094z"
  })];
};

exports.default = _default;